import SuperAdminsTable from './_table.js'
import template from './index.pug'

export default Vue.extend({
  template: template(),
  components: {
    SuperAdminsTable
  },
  data() {
    return {
      superAdmins: [],
      meta: {},
      idCopied: null,
    }
  },
  created() {
    this.$setPageTitle(this.$t('superAdmins.index.title'))
    this.$setBreadcrumbs([
      { label: this.$t('superAdmins.breadcrumbs.index'), route: {} }
    ])
   
  },
  methods: {
    loadSuperAdmins(queryOptions = {}) {
      console.log("📡 Enviando petición a API.superAdmins.index con:", queryOptions)
      API.superAdmins.index(queryOptions).then(({ data, meta }) => {
        console.log("✅ Datos recibidos:", data)
        this.superAdmins = data
        this.meta = meta
      }).catch(error => console.error("❌ Error al cargar super administradores:", error))
    }
  }
})
